export default function wrapAndJoin(array, createSeparator) {
  return array.reduce((acc, item, index) => acc.concat([item, createSeparator(index + 1)]), [createSeparator(0)])
}
